// List of all the possible routes in the app.
//
// `const enum` is used to reduce the generated code file size:
// https://www.typescriptlang.org/docs/handbook/enums.html#const-enums
export const enum RouteNames {
  Home = 'HOME',
  Devices = 'DEVICES',
  Metrics = 'METRICS',
  DeviceMachines = 'DEVICE-MACHINES',
  DeviceDeployment = 'DEVICE-DEPLOYMENT',
  DeviceConfig = 'DEVICE-CONFIG',
  DeviceMetrics = 'DEVICE-METRICS',
  Machine = 'MACHINE',
  Machines = 'MACHINES',
  Flows = 'FLOWS',
  Flow = 'FLOW',
  ADSFlow = 'ADS-FLOW',
  DerbyFlow = 'DERBY-FLOW',
  OEEFlow = 'OEE-FLOW',
  FTPFlow = 'SAM-FTP-FLOW',
  StationTimesFlow = 'ADS-STATION-TIMES-FLOW',
  ADSOnChangeFlow = 'ADS-ON-CHANGE-FLOW',
  Templates = 'TEMPLATES',
  Template = 'TEMPLATE',
  TemplateArchive = 'TEMPLATE-ARCHIVE',
  ArchivedTemplate = 'ARCHIVED-TEMPLATE',
  Namespaces = 'NAMESPACES',
  NamespaceTemplate = 'NAMESPACE-TEMPLATE',
  DataModels = 'DATA-MODELS',
  DataModel = 'DATA-MODEL',
  ExploreAdsVariables = 'EXPLORE-ADS-VARIABLES',
  Version = 'VERSION',
  Users = 'USERS',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  NotFound = 'NOT-FOUND',
  Error = 'ERROR',
  ErrorLogs = 'ERROR-LOGS',
  AccessDenied = 'ACCESS-DENIED',
  FleetControls = 'FLEET-CONTROLS',
  EndpointTags = 'ENDPOINT-TAGS',
  // Deprecated routes
  // ToDo: Removed in the future versions (start of Q4)
  DeprecatedDevices = 'DEPRECATED-DEVICES',
  DeprecatedMachines = 'DEPRECATED-MACHINES',
  DeprecatedMetrics = 'DEPRECATED-METRICS',
  DeprecatedErrorLogs = 'DEPRECATED-ERROR-LOGS',
  DeprecatedTemplates = 'DEPRECATED-TEMPLATES',
  DeprecatedTemplateArchive = 'DEPRECATED-TEMPLATE-ARCHIVE',
  DeprecatedNamespaces = 'DEPRECATED-NAMESPACES',
  DeprecatedDataModels = 'DEPRECATED-DATA-MODELS',
  DeprecatedExploreAdsVariables = 'DEPRECATED-EXPLORE-ADS-VARIABLES',
  DeprecatedUsers = 'DEPRECATED-USERS',
  DeprecatedFleetControls = 'DEPRECATED-FLEET-CONTROLS',
  DeprecatedEndpointTags = 'DEPRECATED-ENDPOINT-TAGS',
}
